export const downloadJSONData = (data: object, fileName?: string, pretty = true): void => {
  const pom = document.createElement('a');
  const url = URL.createObjectURL(
    new Blob(pretty ? [JSON.stringify(data, undefined, 2)] : [JSON.stringify(data)], {
      type: 'application/json',
    }),
  );

  pom.setAttribute('href', url);
  pom.setAttribute('download', `${fileName ?? 'unknown'}.json`);
  pom.click();
  pom.remove();
};
